// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2OGAG","header":"MergedInvoice_header__2l2rv"};